import React, { useEffect } from "react";
import { AppRouter } from "./router";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { uiActions } from "./redux/reducers";
const App = () => {
  const isLoggedIn = useSelector((state: any) => state.UI.JwtToken);
  const dispatch = useDispatch();
  const token = sessionStorage.getItem("newToken");
  useEffect(() => {
    if (!isLoggedIn && token) dispatch(uiActions.setToken(token));
  }, [dispatch, isLoggedIn, token]);
  return (
    <div>
      <AppRouter isUserLoggedIn={token ? true : false} />
    </div>
  );
};

export default App;
